import React, { useEffect, useState } from 'react';
import ChartDiseases from './ChartDiseases';
import ChartFishHealth from './ChartFishHealth';
import ChartLine from './ChartLine';
import ChartOps from './ChartOps';
import { ChartFishGroups, ChartUnits } from "./ChartOutlined";
import ChartStarvings from './ChartStarvings';

interface IProps {
    id?: string
    className?: string
    chart: {
        yLine: any
        yArea: any
        line: any
        area: any
        starvings?: any
        fish_health?: any
        count: number
        units?: any[]
        fish_groups?: any[]
        weeks?: number[]
    }

    ops: any
    rowMax: number
}

const DrawChart: React.FC<IProps> = (props) => {
    const { count, weeks, units = [], fish_groups = [], starvings = [], fish_health = [], area, yLine, line, yArea } = props.chart
    const [xAxis, setXAxis] = useState<any>({})
    const { id, ops, rowMax } = props;

    useEffect(() => {
        setXAxis({
            axisTick: {
                show: false
            },
            type: 'category',
            data: weeks ?? Array.from({ length: count }, (_, i) => `W${i + 1}`),
        })
    }, [count, weeks]);

    return <>
        <ChartFishGroups xAxis={xAxis} series={fish_groups} />
        <ChartUnits xAxis={xAxis} series={units} />
        <ChartFishHealth xAxis={xAxis} series={fish_health} />
        <ChartDiseases xAxis={xAxis} series={area} yLine={yLine} yArea={yArea} />
        <ChartStarvings xAxis={xAxis} series={starvings} />
        <ChartOps xAxis={xAxis} series={ops} rowMax={rowMax} />
        <ChartLine id={id} xAxis={xAxis} series={line} yLine={yLine} className={props.className} />
    </>;
};

export default DrawChart
